import { Link } from "react-router-dom";
import { ArrowRight, Youtube } from "lucide-react";
import { EPISODES, YOUTUBE_CHANNEL } from "@/data/content";
import { EpisodeCard } from "@/components/EpisodeCard";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

export const WatchListen = () => {
  const { t, to } = useLang();
  const w = t.home.watch;
  const featured = EPISODES.filter((e) => e.featured);

  return (
    <section data-testid="watch-listen-section" className="bg-night text-linen">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-24">
        <FadeUp className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#E0A98F] mb-4">{w.kicker}</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight">{w.title}</h2>
            <p className="mt-4 text-base text-linen/70 leading-relaxed">{w.intro}</p>
          </div>
          <a
            href={YOUTUBE_CHANNEL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="watch-listen-youtube-link"
            className="inline-flex shrink-0 items-center gap-2 text-sm font-semibold text-[#E0A98F] hover:text-linen transition-colors"
          >
            <Youtube className="w-5 h-5" /> {w.subscribe}
          </a>
        </FadeUp>

        <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {featured.map((ep) => (
            <StaggerItem key={ep.id}>
              <EpisodeCard ep={ep} dark />
            </StaggerItem>
          ))}
        </Stagger>

        <FadeUp className="mt-12 text-center">
          <Link
            to={to("/podcast")}
            data-testid="see-all-episodes-btn"
            className="inline-flex items-center gap-2.5 rounded-full bg-linen text-espresso px-8 py-4 text-base font-semibold transition-[background-color,transform] duration-200 hover:bg-white [@media(hover:hover)]:hover:-translate-y-0.5"
          >
            {w.seeAll} <ArrowRight className="w-4 h-4" />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
};
